import { Nilable } from "@shared/utils";

export interface ITagInfoDTO {
    active_users: number;
}

export class TagInfoDTO {
    public usuariosActivos = 0;

    constructor(json: Nilable<Partial<ITagInfoDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<ITagInfoDTO>) {
        if (json.active_users != null) {
            this.usuariosActivos = json.active_users;
        }
    }

    public toJSON(): ITagInfoDTO {
        return {
            active_users: this.usuariosActivos
        };
    }
}
